/* loaded by smart-asset */
export default require("./topology~bpTnfhXY.png")